function Content(props) {
  return (
    <main id="app-content" className="flex-shrink-0">
      {props.children}
    </main>
  );
}

export default Content;
